// extracted by mini-css-extract-plugin
export default {"container":"PujZ978EclAqxtXsyFEqNA==","label":"BVUkGilLE5qswQnOz4n0Yg== body-standard","deleteButton":"_3GLu8yDxqkJJByR6kFp8UA=="};